/**
 * Form utility functions for handling multilingual input changes and translations
 */

/**
 * Handles input changes for multilingual forms with translation support
 * @param {Object} currentPayload - The current form payload state
 * @param {*} value - The new value for the field
 * @param {string} field - The field name to update
 * @param {string} [languageCode] - Optional language code for translation fields
 * @returns {Object} Updated payload object
 */
export const handleTranslationInputChange = (currentPayload, value, field, languageCode) => {
  let keyValuePair = {};
  keyValuePair[field] = value;

  if (languageCode) {
    keyValuePair.languages_code = languageCode;

    // Locate translation object if exists
    const translationObjects = currentPayload.translations.filter(
      translation => translation.languages_code === languageCode
    );

    if (translationObjects.length) {
      // Update existing translation
      const updatedTranslations = currentPayload.translations.map(translation => {
        if (translation.languages_code === languageCode) {
          return {
            ...translation,
            ...keyValuePair
          };
        }
        return translation;
      });

      return {
        ...currentPayload,
        translations: updatedTranslations
      };
    } else {
      // Create new translation entry
      return {
        ...currentPayload,
        translations: [
          ...currentPayload.translations,
          keyValuePair
        ]
      };
    }
  }

  // Non-translation field update
  return {
    ...currentPayload,
    ...keyValuePair
  };
};
